import React, { ChangeEvent, KeyboardEvent } from 'react';
import classNames from 'classnames';
const styles = require('./textarea.module.scss');

interface Props {
  defaultValue?: string;
  className?: string;
  handleChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  handleKeyDown?: (event: KeyboardEvent<HTMLTextAreaElement>) => void;
  id?: string;
  label?: string;
  name?: string;
  placeholder?: string;
  required?: boolean;
  rows?: number;
  color?: string;
  maxLength?: number;
  showCharacterCount?: boolean;
  textareaRef?: React.Ref<HTMLTextAreaElement>;
}

export default class Textarea extends React.Component<Props, {}> {
  notesRef: any;

  constructor(props) {
    super(props);
    this.notesRef = React.createRef();
  }

  get value() {
    return this.notesRef.current.value;
  }

  styles() {
    return classNames(
      styles.textarea,
      this.props.placeholder ? styles.extra : null,
      styles[this.props.color],
      this.props.className
    );
  }

  render() {
    const { defaultValue, label, required, showCharacterCount, maxLength, name, rows, placeholder, handleChange, handleKeyDown, textareaRef } = this.props;
    const currentLength = defaultValue?.length || 0;

    return (
      <>
        {label && (
          <label className={styles.label}>
            {label}
            {required && <span className={styles.required}> *</span>}
          </label>
        )}
        <div className={showCharacterCount ? styles.textareaWrapper : undefined}>
          <textarea
            className={this.styles()}
            defaultValue={defaultValue}
            name={name}
            ref={textareaRef || this.notesRef}
            rows={rows}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            maxLength={maxLength}
          />
          {showCharacterCount && maxLength && (
            <div className={styles.characterCount}>
              {currentLength}/{maxLength}
            </div>
          )}
        </div>
      </>
    );
  }
}
